import { Breakpoints, styled } from "@volkswagen-onehub/components-core";

export const ContainerMain = styled.div`
  width: 100%;
  margin: ${(props) => props.theme.size.grid002} auto 0;
  padding: 0 ${(props) => props.theme.size.grid001};

  @media screen and (min-width: ${Breakpoints.b960}px) {
    padding: 0 ${(props) => props.theme.size.grid002} 0;
    margin-top: ${(props) => props.theme.size.dynamic0140};
  }
`;

export const CTAWrapper = styled.div`
  min-width: 200px;

  button, a {
    width: 100%;
    padding: 1rem;
    border-width: 2px;
  }
`;